import React from 'react';

import type { Text } from '@zillow/constellation';
import { FormField, Heading, Label, Textarea } from '@zillow/constellation';

import type { Section } from '../../../models';
import type { HTMLElementEvent } from '../../../models/Types';
import { WASTE_AND_RECYCLING } from '../../../constants';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

function WasteAndRecycling({ section, setSectionValues }: Props) {
  function onCollectionDayChange(event: HTMLElementEvent<typeof Text>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [WASTE_AND_RECYCLING.FIELD_NAME.COLLECTION_DAY]: value,
    });
  }

  function onStorageLocationChange(event: HTMLElementEvent<typeof Text>) {
    const { value } = event.currentTarget;

    setSectionValues({
      [WASTE_AND_RECYCLING.FIELD_NAME.OUTSIDE_STORAGE_LOCATION]: value,
    });
  }

  return (
    <>
      <Heading level={6} marginBottom="sm">
        Waste/recycling
      </Heading>
      <FormField
        marginBottom="sm"
        label={<Label>When is collection day for waste and recycling?</Label>}
        control={
          <Textarea
            value={section.getFieldValue(WASTE_AND_RECYCLING.FIELD_NAME.COLLECTION_DAY)}
            onChange={onCollectionDayChange}
          />
        }
      />
      <FormField
        label={<Label>Where is the outside storage location for waste and recycling containers?</Label>}
        control={
          <Textarea
            value={section.getFieldValue(WASTE_AND_RECYCLING.FIELD_NAME.OUTSIDE_STORAGE_LOCATION)}
            onChange={onStorageLocationChange}
          />
        }
      />
    </>
  );
}

export default WasteAndRecycling;
